/*
 * @Author: Fan
 * @Date: 2020-04-13 15:36:59
 * @LastEditTime: 2020-06-17 11:01:58
 * @LastEditors: zhuqiu
 * @Description: 控件拥有的属性和属性的值类型和在设计端属性栏名称. 属性独特的行为是在 conduct文件配置.
 * @FilePath: \frontend\modules\@cloudpivot\form\src\components\ReverseRelevance\schema.ts
 */
import { DataType } from "../../../../form/typings";
import i18n from "../../../i18n";
/**
 * 属性根据类型有要一下几种输入框:
 * string默认显示为input:text
 * string format:date、date-time、time默认显示为input:date
 * string format:binary默认显示为input:file
 * boolean默认显示为select
 * integer默认显示为无小数点input:number
 * number默认显示为带小数点input:number
 *
 * 如果需要定制属性的输入框(比如弹框),则应该在conduct文件配置
 */
export default {
    $id: "ReverseRelevance",
    type: DataType.Object,
    properties: {
        name: {
            type: DataType.String,
            title: i18n.t('dataitem.DataItemName').toString(),
            default: "",
        },
        name_i18n: {
            type: DataType.Object,
            title: i18n.t('dataitem.MultiLanguage').toString(),
        },
        visible: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.Visible').toString(),
            default: true,
        },
        dataItemName: {
            type: DataType.String,
            title: i18n.t('dataitem.DataItemCode').toString(),
        },
        dataItemType: {
            type: DataType.String,
            title: i18n.t('dataitem.DataItemType').toString(),
        },
        style: {
            type: DataType.String,
            title: i18n.t('dataitem.ControlStyle').toString(),
        },
        tips: {
            type: DataType.String,
            title: i18n.t('dataitem.ControlTips').toString(),
        },
        appPackageCode: {
            type: DataType.String,
            title: "",
        },
        appFunctionCode: {
            type: DataType.String,
            title: "",
        },
        schemaCode: {
            type: DataType.String,
            title: i18n.t('dataitem.BizModal2').toString(),
        },
        fieldCode: {
            type: DataType.String,
            title: i18n.t('dataitem.RelevanceField').toString(),
        },
        displayMode: {
            type: DataType.String,
            title: i18n.t('dataitem.DisplayType').toString(),
        },
        listCode: {
            type: DataType.String,
            title: i18n.t('dataitem.QueryList').toString(),
        },
        // isAuthorize: {
        //   type: DataType.Boolean,
        //   title: "临时授权",
        // },
        listDisplayMode: {
            type: DataType.String,
            title: i18n.t('dataitem.DisplayType2').toString(),
        },
        conditions: {
            type: DataType.String,
            title: i18n.t('dataitem.QueryConditions').toString(),
        },
        mobileConditions: {
            type: DataType.String,
            title: i18n.t('dataitem.MobileQueryConditions').toString(),
        },
        // displayFormula: {
        //   type: DataType.String,
        //   title: i18n.t('dataitem.DisplayConditions').toString(),
        // },
        // schemaCode: {
        //   type: DataType.String,
        //   title: i18n.t('dataitem.BizModal').toString(),
        // },
        // queryCode: {
        //     type: DataType.String,
        //     title: i18n.t('dataitem.QueryList').toString(),
        // },
        // displayField: {
        //     type: DataType.String,
        //     title: i18n.t('dataitem.DisplayField').toString(),
        // },
        // mappings: {
        //     type: DataType.String,
        //     title: i18n.t('dataitem.MappingField').toString(),
        // },
        // conditions: {
        //     type: DataType.String,
        //     title: i18n.t('dataitem.QueryConditions').toString(),
        // },
        // mobileConditions: {
        //     type: DataType.String,
        //     title: i18n.t('dataitem.MobileQueryConditions').toString(),
        // },
        // linkMode: {
        //     type: DataType.Boolean,
        //     title: '显示链接模式'
        // },
        // selectMode: {
        //     type: DataType.String,
        //     title: '选择方式'
        // },
        // isAuthorize: {
        //     type: DataType.Boolean,
        //     title: '临时授权'
        // },
        // defaultVal: {
        //     type: DataType.String,
        //     title: i18n.t('dataitem.DefaultValue').toString(),
        // },
        onChange: {
            type: DataType.String,
            title: i18n.t('dataitem.ChangeEvent').toString(),
        },
        requiredFormula: {
            type: DataType.String,
            title: i18n.t('dataitem.RequiredFormula').toString(),
        },
        readonlyFormula: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.ReadonlyFormula').toString(),
            default: false,
        },
        relativeType: {
            type: DataType.String,
            title: i18n.t('dataitem.RelevanceFieldType').toString(),
        },
        labelVisible: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.LabelVisible').toString(),
            default: true,
        },
    },
};
